<mat-card class="dialog-card">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar flex flex-row items-center justify-between" color="accent">
      <h1 class="dialog-card-title">{{ title }}</h1>
      <button (click)="close()" class="regular-round-button" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>
  <mat-card-content class="dialog-card-content p-4">
    <form [formGroup]="businessProfileFrom" class="flex flex-col">
      <iot-platform-ui-async-autocomplete
        (reset)="resetEntity()"
        (search)="resetEntity()"
        (selectionChanged)="onEntitySelection($event)"
        [data]="sortedEntities()"
        [disabled]="!!data?.organization || !!data?.businessProfile"
        [displayKey]="'label'"
        [displaySearchIcon]="false"
        [filterKey]="'label'"
        [initialItem]="initialEntity()"
        [minLength]="1"
        [placeholder]="'IOT_DICTIONARY.ENTITY'"
        [required]="true"
        [showSpinner]="entitiesLoading()"
      />
      <mat-form-field color="accent">
        <mat-label>{{ 'I18N_ADMIN.DIALOG.ADD_BP.PLACEHOLDER_NAME' | translate }}</mat-label>
        <input formControlName="nameControl" matInput maxlength="50" required />
        @if (nameControl.invalid && nameControl.errors?.nameExists) {
          <mat-hint align="end">
            <span class="dialog-card-input-error">{{ 'I18N_ADMIN.DIALOG.COMMON.ERROR_MESSAGE.DUPLICATE_NAME' | translate }}</span>
          </mat-hint>
        }
      </mat-form-field>
      <iot-platform-ui-timezone-autocomplete
        (reset)="resetTimezone()"
        (selectionChange)="onTimezoneSelection($event)"
        [clearOnSelect]="false"
        [displayOffset]="true"
        [initialItem]="initialTZ"
        [required]="true"
      >
      </iot-platform-ui-timezone-autocomplete>
      <div class="flex flex-row items-center justify-start gap-2.5">
        <mat-label id="chart-period-radio-group-label">{{ 'I18N_ADMIN.BUSINESS_PROFILES.DETAIL.CHART_DEFAULT_PERIOD' | translate }} </mat-label>
        <mat-radio-group
          aria-labelledby="chart-period-radio-group-label"
          class="example-radio-group flex flex-row gap-2.5"
          color="accent"
          formControlName="chartPeriodControl"
        >
          <mat-radio-button [value]="1">{{ 'I18N_ADMIN.BUSINESS_PROFILES.DETAIL.CHART_1_DAY' | translate }} </mat-radio-button>
          <mat-radio-button [value]="7">{{ 'I18N_ADMIN.BUSINESS_PROFILES.DETAIL.CHART_7_DAY' | translate }} </mat-radio-button>
          <mat-radio-button [value]="30">{{ 'I18N_ADMIN.BUSINESS_PROFILES.DETAIL.CHART_30_DAY' | translate }} </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="flex flex-row items-center justify-start gap-2.5">
        <mat-label>{{ 'I18N_ADMIN.BUSINESS_PROFILES.DETAIL.DEFAULT_TIMESERIES_DISPLAY_MODE' | translate }}</mat-label>
        <mat-radio-group
          aria-labelledby="chart-display-radio-group-label"
          class="flex flex-row gap-2.5"
          color="accent"
          formControlName="timeseriesDisplayModeControl"
        >
          @for (mode of TimeseriesDisplayMode | keyvalue; track mode.key) {
            <mat-radio-button [value]="mode.key">{{ 'I18N_ADMIN.BUSINESS_PROFILES.DETAIL.TIMESERIES_DISPLAY_MODE.' + mode.key | translate }} </mat-radio-button>
          }
        </mat-radio-group>
      </div>
      <div class="slider-container flex flex-row items-center justify-start gap-2.5">
        <mat-label id="stock-visibility-radio-group-label">{{ 'I18N_ADMIN.BUSINESS_PROFILES.DETAIL.STOCK_SITES' | translate }} </mat-label>
        <mat-slide-toggle color="accent" formControlName="stockVisibilityControl">
          {{ 'I18N_ADMIN.BUSINESS_PROFILES.DETAIL.VISIBLE' | translate }}
        </mat-slide-toggle>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions class="dialog-card-actions flex flex-row items-center justify-end">
    <button (click)="close()" class="button-regular" mat-button>{{ 'IOT_DICTIONARY.CANCEL' | translate }}</button>
    <button (click)="save()" [disabled]="!businessProfileFrom.valid || businessProfileFrom.pending" class="button-regular" color="accent" mat-raised-button>
      {{ 'IOT_DICTIONARY.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
